import React from 'react'
import { Spinner } from '../../assets/svg/Spinner'
// eslint-disable-next-line no-unused-vars
import { IButton } from '../../interfaces/IButton'

import { Container } from './styles'

export const Button: React.FC<IButton> = ({ children, ...props }) => {
  const getSpinnersColor = () => {
    if (props.variant === 'outline') {
      return props.background || '#333333'
    }

    return props.color || '#FAFAFA'
  }

  if (props.loading) {
    return (
      <Container {...props} className='ui-intuix-button'>
        <i>
          <Spinner color={getSpinnersColor()} />
        </i>
        Carregando
      </Container>
    )
  }

  return (
    <Container {...props} className='ui-intuix-button'>
      {children}
    </Container>
  )
}
